import React, { memo } from "react";
import { HighlightOff } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const CloseTicketNode = memo(({ id, data, isConnectable, selected }) => {
  const sendFarewell = data?.sendFarewellMessage !== false;
  const customMessage = String(data?.customFarewellMessage || "").trim();

  let subtitle = "Encerra o atendimento";
  if (customMessage) {
    subtitle =
      customMessage.length > 48 ? `${customMessage.slice(0, 48)}…` : customMessage;
  } else if (sendFarewell) {
    subtitle = "Com mensagem de despedida";
  } else {
    subtitle = "Sem mensagem de despedida";
  }

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<HighlightOff />}
      title="Fechar Ticket"
      color="#C62828"
      bgColor="#FFEBEE"
      isConnectable={isConnectable}
      selected={selected}
    >
      <div
        style={{
          fontSize: 11,
          color: "#B71C1C",
          fontWeight: 600,
          padding: "4px 8px",
          borderRadius: 6,
          background: "#fff",
          border: "1px solid #EF9A9A",
        }}
      >
        {subtitle}
      </div>
    </NodeWrapper>
  );
});

CloseTicketNode.displayName = "CloseTicketNode";
export default CloseTicketNode;
